export const musicStyles = [
  { value: 'french_variety', label: 'French Variety 🇫🇷', labelFr: 'Variété française 🇫🇷', labelEs: 'Variedad francesa 🇫🇷', labelIt: 'Varietà francese 🇫🇷' },
  { value: 'pop', label: 'Pop 🎤', labelFr: 'Pop 🎤', labelEs: 'Pop 🎤', labelIt: 'Pop 🎤' },
  { value: 'rock', label: 'Rock 🎸', labelFr: 'Rock 🎸', labelEs: 'Rock 🎸', labelIt: 'Rock 🎸' },
  { value: 'jazz', label: 'Jazz 🎷', labelFr: 'Jazz 🎷', labelEs: 'Jazz 🎷', labelIt: 'Jazz 🎷' },
  { value: 'blues', label: 'Blues 🎹', labelFr: 'Blues 🎹', labelEs: 'Blues 🎹', labelIt: 'Blues 🎹' },
  { value: 'soul', label: 'Soul 🎙️', labelFr: 'Soul 🎙️', labelEs: 'Soul 🎙️', labelIt: 'Soul 🎙️' },
  { value: 'rnb', label: 'R&B 💜', labelFr: 'R&B 💜', labelEs: 'R&B 💜', labelIt: 'R&B 💜' },
  { value: 'funk', label: 'Funk 🕺', labelFr: 'Funk 🕺', labelEs: 'Funk 🕺', labelIt: 'Funk 🕺' },
  { value: 'reggae', label: 'Reggae 🇯🇲', labelFr: 'Reggae 🇯🇲', labelEs: 'Reggae 🇯🇲', labelIt: 'Reggae 🇯🇲' },
  { value: 'latino', label: 'Latino 💃', labelFr: 'Latino 💃', labelEs: 'Latino 💃', labelIt: 'Latino 💃' },
  { value: 'rap', label: 'Rap 🎧', labelFr: 'Rap 🎧', labelEs: 'Rap 🎧', labelIt: 'Rap 🎧' },
  { value: 'hiphop', label: 'Hip-hop 🔥', labelFr: 'Hip-hop 🔥', labelEs: 'Hip-hop 🔥', labelIt: 'Hip-hop 🔥' },
  { value: 'country', label: 'Country 🤠', labelFr: 'Country 🤠', labelEs: 'Country 🤠', labelIt: 'Country 🤠' },
  { value: 'folk', label: 'Folk 🪕', labelFr: 'Folk 🪕', labelEs: 'Folk 🪕', labelIt: 'Folk 🪕' },
  { value: 'gospel', label: 'Gospel 🙏', labelFr: 'Gospel 🙏', labelEs: 'Gospel 🙏', labelIt: 'Gospel 🙏' },
  { value: 'kpop', label: 'K-pop 🇰🇷', labelFr: 'K-pop 🇰🇷', labelEs: 'K-pop 🇰🇷', labelIt: 'K-pop 🇰🇷' }
];

export const languages = [
  { value: 'en', label: 'English 🇬🇧', labelFr: 'Anglais 🇬🇧', labelEs: 'Inglés 🇬🇧', labelIt: 'Inglese 🇬🇧' },
  { value: 'fr', label: 'French 🇫🇷', labelFr: 'Français 🇫🇷', labelEs: 'Francés 🇫🇷', labelIt: 'Francese 🇫🇷' },
  { value: 'es', label: 'Spanish 🇪🇸', labelFr: 'Espagnol 🇪🇸', labelEs: 'Español 🇪🇸', labelIt: 'Spagnolo 🇪🇸' },
  { value: 'it', label: 'Italian 🇮🇹', labelFr: 'Italien 🇮🇹', labelEs: 'Italiano 🇮🇹', labelIt: 'Italiano 🇮🇹' },
  { value: 'da', label: 'Danish 🇩🇰', labelFr: 'Danois 🇩🇰', labelEs: 'Danés 🇩🇰', labelIt: 'Danese 🇩🇰' }
];

export const ambiances = [
  { value: 'joyful', label: 'Joyful ☀️', labelFr: 'Joyeux ☀️', labelEs: 'Alegre ☀️', labelIt: 'Gioioso ☀️' },
  { value: 'festive', label: 'Festive 🥳', labelFr: 'Festif 🥳', labelEs: 'Festivo 🥳', labelIt: 'Festivo 🥳' },
  { value: 'playful', label: 'Playful 🤭', labelFr: 'Espiègle 🤭', labelEs: 'Juguetón 🤭', labelIt: 'Giocoso 🤭' },
  { value: 'dynamic', label: 'Dynamic 🔥', labelFr: 'Dynamique 🔥', labelEs: 'Dinámico 🔥', labelIt: 'Dinamico 🔥' },
  { value: 'emotional', label: 'Emotional 🥹', labelFr: 'Émouvant 🥹', labelEs: 'Emotivo 🥹', labelIt: 'Emotivo 🥹' },
  { value: 'romantic', label: 'Romantic ❤️', labelFr: 'Romantique ❤️', labelEs: 'Romántico ❤️', labelIt: 'Romantico ❤️' },
  { value: 'grateful', label: 'Grateful 🤗', labelFr: 'Reconnaissant 🤗', labelEs: 'Agradecido 🤗', labelIt: 'Grato 🤗' },
  { value: 'tender', label: 'Tender 🌸', labelFr: 'Tendre 🌸', labelEs: 'Tierno 🌸', labelIt: 'Tenero 🌸' },
  { value: 'nostalgic', label: 'Nostalgic 🎞️', labelFr: 'Nostalgique 🎞️', labelEs: 'Nostálgico 🎞️', labelIt: 'Nostalgico 🎞️' }
];

export const eras = [
  { value: '1950s', label: '1950s', labelFr: 'Années 50', labelEs: 'Años 50', labelIt: 'Anni 50' },
  { value: '1960s', label: '1960s', labelFr: 'Années 60', labelEs: 'Años 60', labelIt: 'Anni 60' },
  { value: '1970s', label: '1970s', labelFr: 'Années 70', labelEs: 'Años 70', labelIt: 'Anni 70' },
  { value: '1980s', label: '1980s', labelFr: 'Années 80', labelEs: 'Años 80', labelIt: 'Anni 80' },
  { value: '1990s', label: '1990s', labelFr: 'Années 90', labelEs: 'Años 90', labelIt: 'Anni 90' },
  { value: '2000s', label: '2000s', labelFr: 'Années 2000', labelEs: 'Años 2000', labelIt: 'Anni 2000' },
  { value: '2010s', label: '2010s', labelFr: 'Années 2010', labelEs: 'Años 2010', labelIt: 'Anni 2010' },
  { value: '2020s', label: '2020 - Today', labelFr: '2020 - Aujourd\'hui', labelEs: '2020 - Hoy', labelIt: '2020 - Oggi' }
];

export const exampleSongs = [
  {
    id: 1,
    title: 'Forever With You',
    style: 'Pop',
    language: 'English',
    voice: 'Female',
    era: '2020 - Today',
    ambiance: 'Romantic',
    coverImage: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=300&h=300&fit=crop'
  },
  {
    id: 2,
    title: 'My Best Friend',
    style: 'Jazz',
    language: 'English',
    voice: 'Male',
    era: '2010s',
    ambiance: 'Joyful',
    coverImage: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=300&h=300&fit=crop'
  },
  {
    id: 3,
    title: 'Birthday Song for Sarah',
    style: 'Pop',
    language: 'English',
    voice: 'Female',
    era: '2020 - Today',
    ambiance: 'Festive',
    coverImage: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop'
  },
  {
    id: 4,
    title: 'Retirement Celebration',
    style: 'Reggae',
    language: 'English',
    voice: 'Male',
    era: '2010s',
    ambiance: 'Joyful',
    coverImage: 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=300&h=300&fit=crop'
  },
  {
    id: 5,
    title: 'Wedding Anniversary',
    style: 'Latino',
    language: 'Spanish',
    voice: 'Duo',
    era: '2020 - Today',
    ambiance: 'Romantic',
    coverImage: 'https://images.unsplash.com/photo-1415201364774-f6f0bb35f28f?w=300&h=300&fit=crop'
  },
  {
    id: 6,
    title: 'My Little Star',
    style: 'Folk',
    language: 'English',
    voice: 'Female',
    era: '2020 - Today',
    ambiance: 'Tender',
    coverImage: 'https://images.unsplash.com/photo-1487180144351-b8472da7d491?w=300&h=300&fit=crop'
  },
  {
    id: 7,
    title: 'Thank You Mom',
    style: 'Soul',
    language: 'English',
    voice: 'Male',
    era: '2000s',
    ambiance: 'Emotional',
    coverImage: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=300&h=300&fit=crop'
  },
  {
    id: 8,
    title: 'Mi Mejor Amigo',
    style: 'Rock',
    language: 'Spanish',
    voice: 'Male',
    era: '1970s',
    ambiance: 'Dynamic',
    coverImage: 'https://images.unsplash.com/photo-1498038432885-c6f3f1b912ee?w=300&h=300&fit=crop'
  }
];

export const streamingPlatforms = [
  { name: 'Spotify', logo: 'https://upload.wikimedia.org/wikipedia/commons/1/19/Spotify_logo_without_text.svg' },
  { name: 'Apple Music', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5f/Apple_Music_icon.svg' },
  { name: 'Deezer', logo: 'https://upload.wikimedia.org/wikipedia/commons/3/32/Deezer_logo.svg' },
  { name: 'YouTube Music', logo: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/Youtube_Music_icon.svg' },
  { name: 'Amazon Music', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/4b/Amazon_Music_logo.svg' }
];
